import { Controller } from 'stimulus'

// Log usage on the phone's inventory item page (app/views/mobile/inventory/show):
// a sheet over the page with the lot, amount, and note. The form posts as a
// normal page; a refused amount re-renders the page with the sheet open.
export default class extends Controller {
  static targets = ['sheet']

  connect() {
    this.onKey = this.onKey.bind(this)
    if (this.hasSheetTarget && !this.sheetTarget.hidden) this.lock()
  }

  disconnect() {
    this.unlock()
  }

  open() {
    this.sheetTarget.hidden = false
    this.lock()
    const amount = this.sheetTarget.querySelector('input[name="qty_used"]')
    if (amount) amount.focus()
  }

  close() {
    this.sheetTarget.hidden = true
    this.unlock()
  }

  lock() {
    document.body.classList.add('mb-sheet-open')
    document.addEventListener('keydown', this.onKey)
  }

  unlock() {
    document.body.classList.remove('mb-sheet-open')
    document.removeEventListener('keydown', this.onKey)
  }

  onKey(event) {
    if (event.key === 'Escape') this.close()
  }
}
